import * as Yup from "yup";
import { requiredTextFieldMinMax } from "./commonValidationSchemas";
import { labelValues, softwareApplicationValues } from "./tagsValidationSchema";
import { uploadedScorms } from "./filesValidationSchema";

const packageNameLengths = {
  min: 3,
  max: 120,
};

const descriptionLengths = {
  min: 3,
  max: 256,
};

const scormConfiguration = Yup.object().shape({
  title: requiredTextFieldMinMax("Package Name", packageNameLengths.min, packageNameLengths.max),
  description: requiredTextFieldMinMax("Description", descriptionLengths.min, descriptionLengths.max),
  thumbnailUrl: Yup.string(),
});

const requiredFileName = Yup.string().trim().required("SCORM file is required");

export const getScormConfigurationSchema = (shouldValidateFiles: boolean) =>
  shouldValidateFiles
    ? scormConfiguration.concat(Yup.object().shape({ uploadedFiles: uploadedScorms }))
    : scormConfiguration.concat(Yup.object().shape({ fileName: requiredFileName }));

export const settingsValidationSchema = Yup.object().shape({
  labels: labelValues,
  softwareApplications: softwareApplicationValues,
});
